/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: CreateEditPage
 * Reason: CRUD component for creating and editing SmSigningProcessSigner entities using metadata-driven forms via mvs-crud-object with parent context support.
 */
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {
    ObjectChangeInformation,
    ObjectChangeInformationActionEnum
} from '../../../../../core/shared/logic/object-change-information';
import {DtoImportObjectContext} from '../../../../../core/shared/dto/dto.import.object.context';
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';

@Component({
    selector: 'mvs-sm-signer-crud',
    templateUrl: './sm-signer-crud.component.html',
    styleUrls: ['./sm-signer-crud.component.scss'],
    standalone: false
})
export class SmSignerCrudComponent implements OnInit, OnChanges {

    @Input() objectId: number;
    @Input() signingProcessId: number;
    @Output() onChangedObject = new EventEmitter<ObjectChangeInformation>();

    objectType: string = 'sm.SmSigningProcessSigner';
    parentContext: DtoImportObjectContext;
    formDirty: boolean = false;

    ngOnInit(): void {
        this.initComponent();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // React to input changes
    }

    initComponent(): void {
        if (this.signingProcessId) {
            const parentId = new ObjectIdentifier('sm.SmSigningProcess', this.signingProcessId);
            this.parentContext = DtoImportObjectContext.createFromObjectIdentifier(parentId);
        }
    }

    /**
     * Navigation guard. Returns true if the form is clean or the user confirms leaving.
     */
    canDeactivate(): Observable<boolean> | boolean {
        if (this.formDirty) {
            return confirm('You have unsaved changes. Leave anyway?');
        }
        return true;
    }

    /**
     * Handle create/update/delete events from the CRUD object component.
     * Checks event.action before emitting to parent.
     */
    handleChanged(event: ObjectChangeInformation): void {
        if (event.action === ObjectChangeInformationActionEnum.created ||
            event.action === ObjectChangeInformationActionEnum.updated) {
            this.onChangedObject.emit(event);
        }
    }

    /**
     * Handle form dirty state changes from the CRUD object component.
     */
    onFormDirty(isDirty: boolean): void {
        this.formDirty = isDirty;
    }
}
